// @ts-nocheck
import { TabsContent } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RetroBody } from "./RetroTab";

export default function WynikiTab({ ctx }: { ctx: any }) {
  const { item, selectedId, retroM, clickAi, retroRunning } = ctx;
  const qc = useQueryClient();
  const patchM = useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) => api.carouselLessonPatch(id, { status }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["carousel", selectedId] });
    },
  });
  const published = item?.status === "published";
  const insights = item?.insights || {};
  const retro = item?.retro_results;
  const lessons = (item?.lessons || []).filter((l: any) => (l.source || "") === "results");
  return (
    <TabsContent value="wyniki" className="mt-0 space-y-5">
      {!published ? (
        <p className="text-sm text-muted-foreground">Wyniki i wnioski z metryk pojawią się po publikacji (auto ~48 h).</p>
      ) : (
        <>
          <Card className="border-slate-200 bg-white shadow-sm">
            <CardHeader>
              <CardTitle className="text-base">Metryki</CardTitle>
            </CardHeader>
            <CardContent className="grid gap-2 text-sm sm:grid-cols-4">
              <div>Reach: {insights.reach ?? "-"}</div>
              <div>Saves: {insights.saved ?? "-"}</div>
              <div>Via (sesje): {insights.clicks_via ?? "-"}</div>
              <div>Score: {insights.score ?? "-"}</div>
            </CardContent>
          </Card>
          <RetroBody
            title="Wnioski z wyników"
            tip="Auto po ~48 h, gdy są insights. Zatwierdzone wnioski też idą do globalnej pamięci."
            retro={retro}
            lessons={lessons}
            running={retroRunning || item?.llm_status === "retro"}
            onRun={() => clickAi("retro", () => retroM.mutate({ phase: "results" }))}
            onPatch={(id, status) => patchM.mutate({ id, status })}
            patchPending={patchM.isPending}
            emptyHint="Czekam na insights i auto-job, albo uruchom teraz."
            runLabel={retro ? "Uruchom ponownie" : "Uruchom wnioski z wyników teraz"}
          />
        </>
      )}
    </TabsContent>
  );
}
